const STORAGE_PREFIX = "teccc.trayBoard.";

export const loadTrayBoardState = (surface = "") => {
  const key = String(surface || "").trim();
  if (!key) {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveTrayBoardState = (surface = "", state = {}) => {
  const key = String(surface || "").trim();
  if (!key) {
    return;
  }
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, JSON.stringify(state));
  } catch {
    // ignore quota / private mode
  }
};
